import { j as json } from "../../../../chunks/index.js";
import Stripe from "stripe";
const SECRET_STRIPE_SECRET_KEY = "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";
const SECRET_BASE_URL = "https://mediumsans.com";
const stripe = new Stripe(SECRET_STRIPE_SECRET_KEY);
async function POST({ request }) {
  try {
    const { items, currency } = await request.json();
    const session = await stripe.checkout.sessions.create({
      payment_method_types: ["card"],
      line_items: items.map((item) => ({
        price_data: {
          currency: currency.toLowerCase(),
          product_data: {
            name: item.title,
            description: item.description,
            images: [item.image]
          },
          unit_amount: Math.round(item.price * 100)
          // Stripe expects amounts in cents
        },
        quantity: item.quantity
      })),
      mode: "payment",
      success_url: `${SECRET_BASE_URL}/success`,
      cancel_url: `${SECRET_BASE_URL}`
    });
    return json({ url: session.url });
  } catch (error) {
    console.error("Error creating checkout session:", error);
    return json({ error: "Failed to create checkout session" }, { status: 500 });
  }
}
export {
  POST
};
